import type { SetOrganisationWebhookStatusMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { SetOrganisationWebhookStatusDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export interface SetWebhookStatusInput {
  id: string;
  // 'failed' is system-set, not user-settable — only active/paused.
  status: 'active' | 'paused';
}

/**
 * tRPC `webhook.setStatus`, or the v2 `setOrganisationWebhookStatusApi`
 * action on the legacy path.
 */
export const useUpdateWebhookStatus = createMutationHook({
  name: 'updateWebhookStatus',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.webhook.setStatus.mutationOptions({ onSuccess }),
  mapInput: (input: SetWebhookStatusInput) => ({
    id: input.id,
    Status: input.status,
  }),
  invalidate: (trpc) => [trpc.frontend.webhook.list.queryKey()],
  mapResponse: (): SetOrganisationWebhookStatusMutation => ({
    setOrganisationWebhookStatusApi: {
      __typename: 'GenericMutationOutput',
      affected_rows: 1,
    },
  }),
  graphqlDocument: SetOrganisationWebhookStatusDocument,
  graphqlVariables: (input: SetWebhookStatusInput) => ({
    object: { Id: input.id, Status: input.status },
  }),
  evictFields: ['organisation_webhook'],
});
